import { navigationService } from 'src/config/rootService';
import { ContentLinkNode } from 'src/generated/webapp_gql';
import { voidFunction } from 'src/shared/helpers/voidFunction';

export const contentLinkNodeNavigateTo = (link: ContentLinkNode): VoidFunction => {
    switch (link.__typename) {
        case 'MeditationLinkNode':
            return () => navigationService.navigate(`/meditation/${link.meditation?.slug}`);
        case 'ProgramLinkNode':
            return () => navigationService.navigate(`/program/${link.program?.slug}`);
        case 'CircleSeriesLinkNode':
            return () =>
                window.open(
                    `https://circles.modernhealth.com/series/${link.circleSeries?.slug}`,
                    '_blank',
                );
        case 'ExternalLinkNode':
            return () => link.url && window.open(link.url, '_blank');
        case 'InternalLinkNode':
            return () => link.path && navigationService.navigate(link.path);
        case 'CircleSessionLinkNode':
            return () => window.open(link.circleSession?.rsvpLink, '_blank');
        case 'CircleTopicLinkNode':
            return () =>
                window.open(`https://example.com/series/${link.circleTopic?.slug}`, '_blank');
        default:
            return voidFunction;
    }
};
